import React, { FC, useState } from "react";
import style from "./style.module.scss";
import MaintenanceDayDrawer from "../maintanaceDayDrawer";
import type { DatePickerProps } from "antd";
import { DatePicker } from "antd";
import "./style.scss";
import UpcomingMaintanenceCard from "./maintenaceCard";
import { useParams } from "react-router-dom";
export interface maintenanceday {
  data: any;
  onUpdate: Function;
  selectDate: Function;
}
const MaintenanceDay: FC<maintenanceday> = ({ data, selectDate, onUpdate }) => {
  const [visible, setVisible] = useState(false);

  // const param = useParams();

  const onChange: DatePickerProps["onChange"] = (date, dateString) => {
    selectDate(dateString);
  };

  return (
    <div className={style.up_coming_visit}>
      <div className={style.dropdown_groups}>
        <DatePicker onChange={onChange} className={style.date_picker} />
        <div className={style.add_monthly_btn} onClick={() => setVisible(true)}>
          <img src="/images/property/plus_icon.svg" alt="" />
          Add maintenance day
        </div>
      </div>
      <div className={style.upcoming_cards}>
        {data &&
          data.map((val: any, index: any) => {
            return <UpcomingMaintanenceCard onupdate={onUpdate} data={val} />;
          })}
      </div>
      <MaintenanceDayDrawer title={'Add maintenance day'} onChange={onUpdate} showDrawer={visible} setShowDrawer={setVisible} />
    </div>
  );
};

export default MaintenanceDay;
